import { FIELD_TYPES } from "./constants";

export function isModernizedTextField(field) {
  return field.type === FIELD_TYPES.modernizedTextField;
}
